import * as _ from 'lodash';
import { fromJS } from 'immutable';

import * as actions from '../actions/comments';

import { fetchingState } from '@constants';

const initialState = fromJS({
  results: [],
  state: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_COMMENTS_FOR_CASE_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.INSERT_COMMENT_TO_CASE_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.DELETE_COMMENT_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }

    case actions.FETCH_COMMENTS_FOR_CASE_SUCCESS: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['results'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.INSERT_COMMENT_TO_CASE_SUCCESS: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(action.data));
    }
    case actions.UPDATE_COMMENT_SUCCESS: {
      const response = _.get(action, 'data.results[0]');
      const results = state.getIn(['results']);

      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(
          ['results'],
          fromJS(
            results
              ? results
                  .toJS()
                  .map(x =>
                    x.noteID === _.get(response, 'noteID') ? response : x,
                  )
              : [],
          ),
        );
    }
    case actions.DELETE_COMMENT_SUCCESS: {
      return state.setIn(['state'], fetchingState.LOADED);
    }

    case actions.FETCH_COMMENTS_FOR_CASE_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    case actions.INSERT_COMMENT_TO_CASE_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};
